// extracted by mini-css-extract-plugin
module.exports = {"button":"CloseButton_button__9rUz_","icon":"CloseButton_icon__ftfWM"};